/**
 * Custom hook for validating reading list rules
 */

import { useState, useEffect } from 'react';
import { validateAllRules } from '../utils/ruleValidation';

/**
 * Hook that automatically validates rules whenever books or rules change
 * @param {Array} rules - Array of rule objects
 * @param {Array} selectedBooks - Array of selected book objects
 * @returns {{validationStatus: Object|null, isLoading: boolean}}
 */
export const useRulesValidation = (rules, selectedBooks) => {
    const [validationStatus, setValidationStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Only validate if there are rules
        if (!rules || rules.length === 0) {
            setValidationStatus(null);
            return;
        }

        setIsLoading(true);

        // Validate asynchronously to avoid blocking UI
        const timeoutId = setTimeout(() => {
            const status = validateAllRules(rules, selectedBooks);
            setValidationStatus(status);
            setIsLoading(false);
        }, 0);

        return () => clearTimeout(timeoutId);
    }, [rules, selectedBooks]);

    return { validationStatus, isLoading };
};
